<template>
  <div id="page-wrapper">
    <v-app-bar
      id="topbar-post-login"
      color="transparent"
      dark
      dense
      fixed
      prominent
    >
      <div class="mt-7">
        <span>SECRETARIA DE EDUCAÇÃO E ESPORTES</span>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title class="d-flex">
        <div class="logo-container">
          <img
            class="app-icon"
            src="https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png"
            alt="brasão-home-64px"
          />
        </div>
      </v-toolbar-title>
    </v-app-bar>

    <div id="background-image-wrapper">
      <vue-page-transition name="fade-in-right" style="margin-top: 8%;">
        <router-view class="page" />
      </vue-page-transition>
    </div>
    <v-main id="main">
      <div class="logo-wrapper mt-7">
        <img
          class="app-icon-logo"
          src="/img/logo_sigofoco_colorido.png"
          alt="brasão-home-64px"
        />
        <div class="welcome-text mt-7">
          <small>
            Seja bem vindo(a) ao Sistema de <br />
            Gestão da Formação Continuada!
          </small>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script>
import {
  PRE_LOGIN_LAYOUT_NAMESPACE,
  BACKGROUND_IMAGE,
  BACKGROUND_IMAGE_VISIBILITY,
} from "store/modules/pre-login-layout";

export default {
  name: "PreLoginLayout",
  data() {
    return {
      
    }
  },
  computed: {
    backgroundImageSrc() {
      return this.$store.getters[`${PRE_LOGIN_LAYOUT_NAMESPACE}/${BACKGROUND_IMAGE}`];
    },
    visibleBackgroundImage() {
      return this.$store.getters[`${PRE_LOGIN_LAYOUT_NAMESPACE}/${BACKGROUND_IMAGE_VISIBILITY}`];
    },
  },
};
</script>

<style lang="scss">
#page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  #background-image-wrapper {
    flex: 1;
    position: relative;
    background-color: rgb(35,30,73);

    .page {
      position: relative;
      z-index: 1;
    }
  }

  #main {
    flex: 1;
    background-color: #ffffff;
    color: rgb(35,30,73);
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;

      .app-icon {
        max-width: 100%;
        max-height: 100%;
      }

      .welcome-text {
        text-align: center;
        margin-top: 10px;

        small {
          font-size: 1.8rem;
          line-height: 1.5;
          font-weight: normal;
        }
      }
    }
  }

      #topbar-post-login {
        .v-toolbar__title {
          display: flex;
          align-items: center;

      .logo-container {
        .app-icon {
          height: 75px;
          width: auto;
          max-width: 500px;
          margin-left: 10px;
          object-fit: contain;
          margin-right: 20px;
          flex-shrink: 0;
        }
      }

      .title-container {
        display: flex;
        align-items: center;
        padding-top: 8px;

        .app-title {
          font-size: 1.5rem;
          color: #ffffff;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
  .app-icon-logo {
    max-width: 90%;
    width: 90%;
  }
</style>